module.exports = __webpack_public_path__ + "static/media/meatometer.72470de5.jpg";